import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import LazyLoad from 'react-lazyload';
import styles from '@utils/styles';
import breakpoints from '@repo/ui-components/breakpoints';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';

const Heading = styled.h2`
  font-weight: ${styles.fontWeight.medium};
`;

const InnerContainer = styled.div`
  display: flex;
  padding: 1rem 0 4.25rem;
  flex-direction: column;

  @media screen and (min-width: ${breakpoints.lg}) {
    flex-direction: row;
  }
`;

const InnerSection = styled.div`
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 0 1rem;

  @media screen and (min-width: ${breakpoints.lg}) {
    width: 33.3%;
  }

  img {
    width: 100%;
    height: 100%;
  }

  a {
    cursor: pointer;
    color: ${styles.colors.gray[700]};
    font-weight: ${styles.fontWeight.medium};
    font-size: ${styles.fontSize['1xl']};

    &:hover {
      color: ${styles.colors.orange[500]};
    }
  }
`;

interface ImageBarProps {
  items: {
    cta_label?: string;
    link?: string;
    original?: string;
    originalAlt?: string;
  }[];
}

const ImageBar = ({ items }: ImageBarProps) => (
  <PageWrapper>
    <Heading>Explore More</Heading>
    <LazyLoad height="100%">
      <InnerContainer>
        {items.map(item => (
          <InnerSection className="gap-4" key={item.cta_label}>
            <Link to={item.link}>
              <img
                src={item.original}
                alt={item.originalAlt}
                width="359"
                height="276"
              />
            </Link>
            <p>
              <Link to={item.link}>{item.cta_label}</Link>
            </p>
          </InnerSection>
        ))}
      </InnerContainer>
    </LazyLoad>
  </PageWrapper>
);

export default ImageBar;
